<template>
  <Transition enter-active-class="transition-all ease-fast-effect">
    <div
      v-if="isActive"
      class="flex flex-row w-full justify-between items-center px-3 bg-surface-container overflow-hidden h-14"
    >
      <div class="flex flex-row items-center">
        <BaseIcon size="20" class="mr-2">{{ icon }}</BaseIcon>
        <span class="text-body-medium">{{ label }}</span>
      </div>
      <div class="flex flex-row items-center">
        <slot />
      </div>
    </div>
  </Transition>
</template>
<script lang="ts" setup>
import BaseIcon from '../../../core/components/base/icon/BaseIcon.vue'

interface Props {
  isActive: boolean
  icon: string
  label: string
}

defineProps<Props>()
</script>
